module.exports = __webpack_public_path__ + "static/media/mobile-multi-sample-bg.6e3e6cc7.jpg";